import Scanner from "@/framework/scans";
export const mocks = Scanner.scanner(require.context(".", true, /.mock.ts/));
